import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom';
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada';
import limparViagens from '../../actions/viagem/limpaViagens';
import { isAmbienteDev } from '../../util/applicationContext';
import elementosPaginaAtual from '../../util/elementosPaginaAtual';
import OpcoesPaginacaoSelecaoEmpresa from './OpcoesPaginacaoSelecaoEmpresa';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import SetasPaginacaoSelecaoEmpresa from './SetasPaginacaoSelecaoEmpresa';
import filtrarSelecaoEmpresa from '../../actions/selecao-empresa/filtrarSelecaoEmpresa';
import limparFiltroSelecaoEmpresa from '../../actions/selecao-empresa/limparFiltroSelecaoEmpresa';
import alterarRegistrosPorPagina from '../../actions/selecao-empresa/alterarRegistrosPorPaginaSelecaoEmpresa';
import determinarPaginaAtual from '../../actions/selecao-empresa/determinarPaginaAtualSelecaoEmpresa';
import Autorizacao from '../../security/Autorizacao';
import {
  PERFIL_ADMIN,
  PERFIL_ADMIN_EMPRESA,
  PERFIL_GESTOR_EMPRESA,
  PERFIL_OPERADOR_EMPRESA
} from '../../security/securityContext';

export class PaginaSelecaoEmpresaAtuacao extends React.Component {
  constructor(props) {
    super(props);
    this.submeterBusca = this.submeterBusca.bind(this);
  }

  handleSelecionarEmpresa(empresa) {
    this.props.limparViagens();
    this.props.alterarEmpresaSelecionada(empresa);
    this.props.history.push('/gestao-empresa')
  }

  componentDidMount() {
    this.props.alterarRegistrosPorPagina(12);
    this.props.determinarPaginaAtual(1);
    this.props.limparFiltroSelecaoEmpresa();
  }

  exibirEmpresas() {
    if (this.props.empresas) {
      const empresas = elementosPaginaAtual(
        this.props.empresas,
        this.props.paginaAtual,
        this.props.registrosPorPagina
      );
      return (
        <div className="col-12 conteudo-internas box-escolha-empresa">
          <CabecalhoRodapeTabela OpcoesPaginacao={OpcoesPaginacaoSelecaoEmpresa}
            BotoesPaginacao={SetasPaginacaoSelecaoEmpresa}
            empresas={this.props.empresas}>
            <div className="container-fluid">
              <div className="row">
                {empresas
                  .map(empresa => <div key={`empresa-selecao-${empresa.id}`} className="col-lg-4 col-md-4 col-6 mb-2" onClick={() => this.handleSelecionarEmpresa(empresa)}>
                    <div className="card card-default text-left" style={{ cursor: 'pointer' }}>
                      <div className='mt-2'>
                        {isAmbienteDev() || !empresa.urlImagem ?
                          <div className="text-center">
                            <p>{empresa.nome}</p>
                            <p className='nm-fantasia'>{empresa.nomeFantasia}</p>
                          </div> :
                          <img alt={empresa.nome} className='card-img' style={{
                            width: '100%',
                            height: '220px'
                          }} src={empresa.urlImagem} />}
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </CabecalhoRodapeTabela>
        </div>)
    }
    return '';
  }

  // eslint-disable-next-line class-methods-use-this
  exibirLinkPassagensVendidas() {
    return (
      <div className="row" style={{ padding: 0 }}>
        <div className="col-md-12" style={{ padding: 0 }}>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN, PERFIL_GESTOR_EMPRESA, PERFIL_OPERADOR_EMPRESA, PERFIL_ADMIN_EMPRESA]}>
            <Link to="/painel-vendas-geral">
              <button className="btn btn-laranja link-passagem-vendida ml-2 mr-4">
                Passagens Vendidas nas empresas abaixo
              </button>
            </Link>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <Link to="/painel-disponiveis-internet">
              <button className="btn btn-laranja link-passagem-vendida">
                Disponíveis para Internet
              </button>
            </Link>
          </Autorizacao>
        </div>
      </div>
    )
  }

  submeterBusca(event) {
    this.props.alterarRegistrosPorPagina(12);
    this.props.determinarPaginaAtual(1);
    this.props.filtrarSelecaoEmpresa(this.props.empresasInicial, event.target.value);
  }

  exibirCampoBusca() {
    return (<React.Fragment>
      <div className="input-group mb-4">
        <span className="input-group-prepend">
          <button id="btn-campo-busca-processo" type="submit"
            className="input-group-text bg-white btn-campo-busca" disabled={true}>
            <i className="material-icons">&#xe8b6;</i>
          </button>
        </span>
        <input className="form-control form-control-lg campo-busca"
          type="text"
          id="campo-busca-legitimado"
          onChange={this.submeterBusca}
          autoComplete="off"
          placeholder="Buscar na lista abaixo" />
      </div>
    </React.Fragment>);
  }

  render() {
    return (
      <React.Fragment>
        <div className="row internas">
          <div className="titulo-tipo mt-4">
            <span>
              <h3>Selecione a empresa que deseja atuar: </h3>
            </span>
          </div>
          <div className="col-12" style={{ padding: 0 }}>
            {this.exibirCampoBusca()}
            {this.exibirLinkPassagensVendidas()}
            {this.exibirEmpresas()}
          </div>
        </div>
      </React.Fragment>)
  }
}

export function mapStateToProps(state) {
  return {
    empresas: state.authentication.empresasSelecao,
    empresasInicial: state.authentication.empresas,
    empresaSelecionada: state.empresaSelecionada,
    paginaAtual: state.paginaAtualSelecaoEmpresa,
    registrosPorPagina: state.registrosPorPaginaSelecaoEmpresa
  }
}

export default withRouter(connect(mapStateToProps, {
  alterarEmpresaSelecionada,
  limparViagens,
  filtrarSelecaoEmpresa,
  limparFiltroSelecaoEmpresa,
  alterarRegistrosPorPagina,
  determinarPaginaAtual
})(PaginaSelecaoEmpresaAtuacao))
